import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { AuthContext } from '../App';

export default function Dashboard() {
  const { user, API } = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [matching, setMatching] = useState(false);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('vi_token');
  const api = axios.create({ baseURL: '/api', headers: { Authorization: `Bearer ${token}` } });

  useEffect(() => {
    loadDashboard();
  }, []);

  const loadDashboard = async () => {
    try {
      const res = await api.get('/user/dashboard');
      setData(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const runMatching = async () => {
    setMatching(true);
    try {
      await api.get('/incentivi/match/profile');
      toast.success('Matching completato!');
      loadDashboard();
    } catch (err) {
      toast.error('Completa prima il profilo aziendale');
    }
    setMatching(false);
  };

  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}><div className="spinner"></div></div>;

  const u = data?.user;
  const incentivi = data?.incentivi || [];
  const profileComplete = u?.azienda && u?.regione && u?.settore;

  return (
    <div className="fade-in" style={{ padding: '30px 0' }}>
      <div className="container">
        <h1 style={{ marginBottom: 8 }}>Dashboard</h1>
        <p style={{ color: '#6b7280', marginBottom: 24 }}>Benvenuto, {u?.nome || u?.email}</p>

        {/* Stats */}
        <div className="dashboard-grid">
          <div className="stat-card">
            <div className="stat-number">{incentivi.length}</div>
            <div className="stat-label">Incentivi Compatibili</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: u?.visura_path ? '#16a34a' : '#f59e0b' }}>
              {u?.visura_path ? 'Si' : 'No'}
            </div>
            <div className="stat-label">Visura Caricata</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: u?.report_sbloccato ? '#16a34a' : '#dc2626' }}>
              {u?.report_sbloccato ? 'Sbloccato' : 'Bloccato'}
            </div>
            <div className="stat-label">Report</div>
          </div>
          <div className="stat-card">
            <div className="stat-number" style={{ color: profileComplete ? '#16a34a' : '#f59e0b' }}>
              {profileComplete ? '100%' : '50%'}
            </div>
            <div className="stat-label">Profilo Completato</div>
          </div>
        </div>

        {/* Actions */}
        <div className="card" style={{ marginBottom: 24, padding: 24 }}>
          <h3 style={{ marginBottom: 16 }}>Azioni Rapide</h3>
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            {!profileComplete && <Link to="/profile" className="btn btn-primary">Completa il Profilo</Link>}
            {!u?.visura_path && <Link to="/profile" className="btn btn-outline">Carica Visura</Link>}
            <button onClick={runMatching} className="btn btn-green" disabled={matching}>
              {matching ? 'Matching in corso...' : 'Avvia Matching Incentivi'}
            </button>
            {incentivi.length > 0 && <Link to="/report" className="btn btn-primary">Vai al Report</Link>}
          </div>
        </div>

        {/* Steps */}
        {!u?.report_sbloccato && (
          <div className="card" style={{ marginBottom: 24, background: '#f0f4ff' }}>
            <h3 style={{ marginBottom: 16 }}>Prossimi Passi</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 28, height: 28, borderRadius: '50%', background: profileComplete ? '#16a34a' : '#e5e7eb', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700 }}>{profileComplete ? '\u2713' : '1'}</span>
                <span style={{ color: profileComplete ? '#16a34a' : '#1f2937' }}>Completa il profilo aziendale</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 28, height: 28, borderRadius: '50%', background: u?.visura_path ? '#16a34a' : '#e5e7eb', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700 }}>{u?.visura_path ? '\u2713' : '2'}</span>
                <span style={{ color: u?.visura_path ? '#16a34a' : '#1f2937' }}>Carica la visura camerale</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 28, height: 28, borderRadius: '50%', background: incentivi.length > 0 ? '#16a34a' : '#e5e7eb', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700 }}>{incentivi.length > 0 ? '\u2713' : '3'}</span>
                <span style={{ color: incentivi.length > 0 ? '#16a34a' : '#1f2937' }}>Avvia il matching incentivi</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 28, height: 28, borderRadius: '50%', background: u?.report_sbloccato ? '#16a34a' : '#e5e7eb', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 700 }}>{u?.report_sbloccato ? '\u2713' : '4'}</span>
                <span style={{ color: u?.report_sbloccato ? '#16a34a' : '#1f2937' }}>Sblocca il report completo</span>
              </div>
            </div>
          </div>
        )}

        {/* Incentivi List */}
        {incentivi.length > 0 && (
          <div>
            <h3 style={{ marginBottom: 16 }}>I Tuoi Incentivi Compatibili ({incentivi.length})</h3>
            <div className="grid-2">
              {incentivi.map((inc, i) => (
                <div key={i} className="incentivo-card">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <span className={`badge ${inc.livello === 'Nazionale' ? 'badge-nazionale' : inc.livello === 'Regionale' ? 'badge-regionale' : 'badge-provinciale'}`}>{inc.livello}</span>
                      <h3 style={{ marginTop: 4 }}>{inc.nome}</h3>
                      <div className="tipo">{inc.tipo}</div>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 24, fontWeight: 800, color: inc.compatibilita >= 70 ? '#16a34a' : inc.compatibilita >= 50 ? '#f59e0b' : '#6b7280' }}>{inc.compatibilita}%</div>
                      <div style={{ fontSize: 11, color: '#6b7280' }}>compatibilita</div>
                    </div>
                  </div>
                  <div style={{ marginTop: 8, fontSize: 13, color: '#6b7280' }}>
                    <span>{inc.agevolazione}</span> | <span>{inc.importo_max}</span>
                  </div>
                  <div className="compat-bar">
                    <div className={`compat-fill ${inc.compatibilita >= 70 ? 'compat-high' : inc.compatibilita >= 50 ? 'compat-medium' : 'compat-low'}`} style={{ width: `${inc.compatibilita}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
